import { ComponentChildren, h } from 'preact'

interface Props {
    message: ComponentChildren,
}

const SetupZendeskCTAWarningBox = ({ message }: Props) => <div className='warning-box'> { message } </div>

export default SetupZendeskCTAWarningBox
